export default __webpack_public_path__ + "static/media/multiplewindows_dark.6b9186c9.svg";